import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { makeRequest } from '@wappsto/redux';
import { useRequest, useMounted } from '@wappsto/blanket';
import { Trans } from 'react-i18next';
import { getRequestErrorMessage } from 'util/helpers';
import { useTranslation } from 'translations';
import updateUnreadNotificationCount from 'hooks/updateUnreadNotificationCount';

const useDeleteNotification = (setUnreadNotifications) => {
  const { tC } = useTranslation('features', 'notifications');
  const dispatch = useDispatch();
  let { request: countRequest } = useRequest('notifications_count_request');
  const mounted = useMounted();

  const showError = (request) => {
    const { message: errorMessage } = getRequestErrorMessage(request, tC);
    message.open({
      key: `notificationDelete_${request.options.url}`,
      type: 'error',
      content: (
        <>
          <Trans tC={tC} i18nKey="notification:notificationDelete.error" />
          <div>{errorMessage}</div>
        </>
      ),
    });
  };

  const deleteNotification = (notification) => {
    const requestId = `delete_notification_${notification.meta.id}`;
    const options = {
      method: 'DELETE',
      url: `/notification/${notification.meta.id}`,
      notificationId: notification.meta.id,
      id: requestId,
    };
    const promise = dispatch(makeRequest(options));
    promise
      .then((result) => {
        if (mounted.current) {
          if (result.ok && result.json) {
            countRequest = updateUnreadNotificationCount(
              notification.meta.id,
              countRequest,
              setUnreadNotifications,
            );
          } else {
            showError(result);
          }
        }
      })
      .catch(() => {
        if (mounted.current) {
          showError({ options });
        }
      });
  };

  return deleteNotification;
};

export default useDeleteNotification;
